const convertMillisecondsToDate = (seconds, monthFormat = 'short') => {
  const date = new Date(seconds * 1000);

  const options = {
    year: 'numeric',
    month: monthFormat,
    day: 'numeric',
  };

  // Get parts separately
  const dateParts = date.toLocaleDateString('en-US', options).split(',');
  const cleanedDate = dateParts.join(''); 

  const timePart = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${cleanedDate}, at ${timePart}`;
};

export default convertMillisecondsToDate;
